<template>
    <el-card shadow="never" class="aui-card--fill">
      <div class="mod-demo__channels}">
        <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
          <el-form-item>
            <el-input v-model="dataForm.callId" placeholder="id" clearable></el-input>
          </el-form-item>
     
          <el-form-item>
            <el-button @click="getDataList()">{{ $t('query') }}</el-button>
          </el-form-item>
   
         
         
        </el-form>
        <el-table v-loading="dataListLoading" :data="dataList" @row-click="getItem" border style="width: 100%;" highlight-current-row>

          <el-table-column  label="选择" header-align="center" align="center" width="50">
            <template slot-scope="scope">
                    <el-radio v-model="selectId" :label="scope.row.id"> <span></span> </el-radio>
            </template>
           
          </el-table-column>
          <el-table-column prop="id" label="ID" header-align="center" align="center"></el-table-column>
         
        </el-table>
        <el-pagination
          :current-page="page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="limit"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="pageSizeChangeHandle"
          @current-change="pageCurrentChangeHandle">
        </el-pagination>
        <!-- 弹窗, 新增 / 修改 -->
        
      </div>
    </el-card>
  </template>
  
  <script>
  import mixinViewModule from '@/mixins/view-module'

  export default {
    mixins: [mixinViewModule],
   
    methods:{
        getItem(row){
            this.tableId = row.id
        }
    },
   
    data () {
      return {
        mixinViewModuleOptions: {
          getDataListURL: '/sys/callback/userIdSearch',
          getDataListIsPage: true,
        //   exportURL: '/sys/channels/export',
        //   deleteURL: '/sys/channels',
         
          deleteIsBatch: true
        },
        tableId:"",
        channelsList:[],
        operationNamesList:[],
        selectId:'',
        dataForm: {
          callId: '',
          operationNames:'',
        }
      }
    },
   
  }
  </script>
  